import React from 'react';
import styled from 'styled-components';
import { Box } from '@cko/primitives';
const StyledFooter = styled(Box) `
  position: sticky;
  bottom: 0;
  z-index: 1;

  background-color: var(--base-bg-primary);
`;
export const StickyFooter = ({ children, footerWidth, parentOffset, testId }) => {
    return (React.createElement(StyledFooter, { "data-testid": testId, style: { width: footerWidth || 'auto', marginLeft: parentOffset ? -parentOffset : 0 } }, children));
};
